// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { BILLING_ROLES } from 'constants';
import { FormCard } from 'components/content-containers/cards';
import Agreement from 'services/data/agreement';
import AgreementForm from 'components/models/agreement/agreement-form';
import SVG from 'components/widgets/icons/svg';
import appHistory from 'app-history';


// Component
class AgreementEdit extends React.Component {
  static propTypes = {
    agreement: PropTypes.object,
    load: PropTypes.func
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { agreement, load } = this.props;
    const update = _.clone(values);

    // Set enddate to an explicit null rather than an empty string
    if (!update.endDate) update.endDate = null;

    return Agreement.update(update)
      .then(() => {
        load();
        appHistory.push(`/admin/agreements/${agreement.id}/summary`);
      });
  }

  render() {
    const { agreement } = this.props;

    const initialValues = _.pick(agreement, ['id', 'title', 'nickname', 'startDate', 'endDate', 'requiresWorkOrder', 'monthly', 'monthlyRate', 'monthlyDescription', 'afterHoursPremium', 'timeDefaultBillable', 'department']);
    initialValues.rates = _.map(BILLING_ROLES, role => {
      const currentRate = _.find(agreement.rates, { role });

      if (!currentRate) return { role };

      return currentRate;
    });
    initialValues.company = _.get(agreement, 'company.id');
    initialValues.signedAgreements = _(agreement.signedAgreements)
      .orderBy(['createdAt'], ['asc'])
      .map(signedAgreement => ([_.assign({ name: signedAgreement.filename }, signedAgreement)]))
      .value();

    return (
      <div className="agreement-summary flex flex-equal-children">
        <FormCard className="agreement-form">
          <div className="form-header">
            <SVG src="svg/agreement.svg" className="agreement" />
            <h5 className="form-title">Edit Agreement</h5>
          </div>
          <AgreementForm
            initialValues={initialValues}
            onSubmit={this.onSubmit}
          />
        </FormCard>
      </div>
    );
  }
}

// Exports
export default connect((state) => ({
  agreement: state.agreements.agreement
}))(AgreementEdit);



// WEBPACK FOOTER //
// ./app/routes/agreement/sub-routes/agreement-edit.js